import {  useState } from "react";
import AchievementData from "./achieveList";
import Iframe from "react-iframe";
import "../styles/achieve.css";
const Achievements = () => {
  const [openPopupIndex, setOpenPopupIndex] = useState(-1);
  const openPopup = (index) => {
    setOpenPopupIndex(index);
  };
  const closePopup = () => {
    setOpenPopupIndex(-1);
  };
  return (
    <>
      <div className="box">
        <div className="section-title" style={{ marginTop: "23px" }}>
          <h2 style={{ color: "white", textAlign: "left" }}>Achievements</h2>
          <p style={{ color: "white", textAlign: "left" }}>
            Check My Achievements
          </p>
        </div>
        <div className="boxx">
          {AchievementData.map((e, index) => {
            const isPopupOpen = openPopupIndex === index;
            return (
              <article data-aos={e.effct}>
                <div
                  className="img img1"
                  onClick={() => openPopup(index)}
                  style={{
                    background: `url(${e.source}) no-repeat center center/cover`,
                  }}
                >
                  <div className="new-link"></div>
                </div>
                <div className="txt">
                  <p>{e.text}</p>
                  <a href={e.link} target="__blank" className="main-link">
                    Certificate
                  </a>
                </div>
                {isPopupOpen && (
                  <div
                    className="popup-overlay"
                    onClick={() => closePopup(index)}
                  >
                    <div className="popup-content">
                      <Iframe
                        url={e.code}
                        width="100%"
                        height="100%"
                        id=""
                        className=""
                        display="block"
                        allowFullScreen
                        position="relative"
                      />
                    </div>
                  </div>
                )}
              </article>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Achievements;
